// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22.5 7.65039L16.3492 1.49963H7.65076L1.5 7.65039V16.3489L7.65076 22.4996H16.3492L22.5 16.3489V7.65039ZM16.5957 8.81797L13.4141 11.9996L16.5957 15.1813L15.1815 16.5955L11.9999 13.4138L8.81753 16.5961L7.40332 15.1819L10.5856 11.9996L7.40332 8.81729L8.81753 7.40308L11.9999 10.5854L15.1815 7.40376L16.5957 8.81797Z"}}]};

const CloseOctagonFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'close-octagon-filled',
    ref,
    icon: element,
  },
));

CloseOctagonFilledIcon.displayName = 'CloseOctagonFilledIcon';

export default CloseOctagonFilledIcon;
